// Site wide enquiry tracking: publishes a Shopify customer event when a visitor taps a phone number,
// the email address or a Get a quote button. A custom pixel forwards these to Google Analytics.
document.addEventListener(
  'click',
  (event) => {
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!link) return;
    const href = link.getAttribute('href') || '';
    let name = '';
    if (href.startsWith('tel:')) name = 'tovan_call_clicked';
    else if (href.startsWith('mailto:') && !link.hasAttribute('data-photo-mail')) name = 'tovan_email_clicked';
    else if (/\/pages\/quote(\b|[?#]|$)/.test(href)) name = 'tovan_quote_button_clicked';
    if (!name) return;
    try {
      window.Shopify?.analytics?.publish?.(name, { page: location.pathname, link_text: (link.textContent || '').trim().slice(0, 60) });
    } catch (error) {
      /* tracking must never block the link */
    }
  },
  { capture: true }
);
